import React from 'react'

function LabeledAnnotation({ data, path, key, videoRef, setPlaying, videoOffset = 0 }) {
    // data has type { label: str, ... }

    return <span style={{ width: '100%', padding: '7px 0' }}>
        <span style={{ color: 'gray' }}>{key}: </span><span style={{fontWeight: 'bold'}}>{data['label']}</span>
    </span >
}

export { LabeledAnnotation };